import * as React from "react";
import useMobileBreakpoint from "@src/hooks/useMobileBreakpoint";
import Paragraph from "@project-stories/elements/Paragraph";
import { Headings } from "@project-stories/elements/Headings/Headings";
import {mobileBreakpoint} from "@src/../entrypoints/theme";

export const AccountPopup = ({ settings, show_always = false}) => {
  const popupRef = React.useRef(null); // Reference to the popup container
  const isMobile = useMobileBreakpoint(mobileBreakpoint);

  const closePopup = () => {
    const closeEvent = new CustomEvent("toggle-display-close", {
      detail: {message: "header-account"},
    });
    window.dispatchEvent(closeEvent);
  }

  const handleClickOutside = (event) => {

    if (!show_always) {
      const isClickInsidePopup = popupRef.current && popupRef.current.contains(event.target);
      const isClickOnAccountIcon = event.target.closest(".account-icon");

      if (!isClickInsidePopup && !isClickOnAccountIcon) {
        closePopup();
      }
    } else {
      // const openEvent = new CustomEvent("toggle-display-open", {
      //   detail: {message: "header-account"},
      // });
      // window.dispatchEvent(openEvent);
    }
  };

  React.useEffect(() => {
    if (!show_always) {
      // Add the event listener when the component is mounted
      document.addEventListener("click", handleClickOutside);
    }

    // Remove the event listener when the component is unmounted
    return () => {
      if (!show_always) {
        document.removeEventListener("click", handleClickOutside);
      }
    };
  }, []);

  // Prevent event propagation when clicking inside the popup to stop the event from closing it
  const handlePopupClick = (event) => {
    event.stopPropagation();
  };
  
  const handleAccountClick = (message) => {
    const event = new CustomEvent("toggle-display-open", {
      detail: { message }
    });
    window.dispatchEvent(event);
    closePopup();
  }

  const renderComponents = () => {
    return (
        <div ref={popupRef} className="container relative account-popup" onClick={handlePopupClick}>
          <div
            className="absolute right-0 w-full account-popup-details lg:w-auto"
            x-data="toggledisplay"
            x-init="$nextTick(() => { init('header-account')})"
          >
            <div
              className="flex flex-col w-full lg:w-[371px] h-[288px] p-[24px] justify-center items-center bg-white z-50 gap-[16px] text-center"
              x-show={`${ show_always ? "true" : "is_open"}`}
            >
              <div className="flex w-full">
                <button
                  onClick={() => handleAccountClick('header-signin')}
                  className="w-full button btn-outline"
                >
                  {settings.cta_button_signin_text}
                </button>
              </div>

              <Headings text={settings.cta_title} type={"h5"} />
              <Paragraph text={settings.cta_text} type={"b3"} />
              <div className="flex w-full">
                <button
                  onClick={() => handleAccountClick('header-signup')}
                  className="w-full button btn-primary"
                >
                  {settings.cta_button_signup_text}
                </button>
              </div>
            </div>
          </div>
        </div>
    );
  };

  return <>{renderComponents()}</>;
};

export default AccountPopup;
